import { render, staticRenderFns } from "./PageLayoutSidebar.vue?vue&type=template&id=2a7ad74c&scoped=true&"
import script from "./PageLayoutSidebar.vue?vue&type=script&lang=js&"
export * from "./PageLayoutSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PageLayoutSidebar.vue?vue&type=style&index=0&id=2a7ad74c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7ad74c",
  null
  
)

export default component.exports